import React, {Component} from 'react';
import {UISTATES, KEYCODES} from '../enum';
import {Results} from './results';
import classnames from 'classnames';
import {resize} from '@homeaway/raf-optimized';
import CSSTransition from 'react-transition-group/CSSTransition';
import {SVGIcon} from '@homeaway/react-svg';
import {CLOSE__16} from '@homeaway/svg-defs';

import {emitDestinationClearedEvent} from '../functions/edap';

export class Typeahead extends Component {
    componentDidMount() {
        this.clearResize = resize(this.onResize);
    }

    componentWillReceiveProps(nextProps) {
        if (
            nextProps.isTypeaheadInputFocus &&
            nextProps.isTypeaheadInputFocus !== this.props.isTypeaheadInputFocus
        ) {
            this.userInput.focus();
        }
    }

    componentDidUpdate() {
        this.sizePopover();
        const element = this.userInput;
        if (this.props.isMobile && this.showResults() && element) {
            window.scrollTo(
                0,
                element.getBoundingClientRect().top + window.scrollY
            );
        }
    }

    componentWillUnmount() {
        if (this.clearResize) {
            this.clearResize();
            this.clearResize = null;
        }
    }

    onResize = () => {
        this.sizePopover();
    };

    sizePopover() {
        const {isMobile, popoverDesktopWidth} = this.props;
        if (!isMobile && popoverDesktopWidth !== 'auto' && this.popover) {
            const oldWidth = Math.round(
                this.popover.getBoundingClientRect().width
            );
            const newWidth = this.getMaxWidth();
            if (newWidth !== oldWidth) {
                this.popover.style.width = `${newWidth}px`;
            }
        }
    }

    assignStateClass() {
        return ` state--${this.props.uistate}`;
    }

    isDestinationSelected() {
        const {selectedDestination, uistate} = this.props;
        return (
            !!selectedDestination &&
            !!selectedDestination.term &&
            selectedDestination.term !== '' &&
            uistate !== UISTATES.SELECT_DESTINATION
        );
    }

    getWindowWidth() {
        if (typeof window !== 'undefined') {
            return window.innerWidth;
        } else if (typeof document !== 'undefined') {
            return (
                document.documentElement.clientWidth ||
                document.body.clientWidth ||
                0
            );
        }
        return 0;
    }

    getMaxWidth() {
        const {popoverDesktopWidth, popoverDesktopMinMarginRight} = this.props;
        const popoverLeft = this.popover
            ? this.popover.getBoundingClientRect().left
            : 0;
        const parsedPopoverDesktopWidth = parseInt(popoverDesktopWidth, 10);
        const maxWidth = Math.max(
            200,
            Math.round(
                this.getWindowWidth() -
                    popoverLeft -
                    (popoverDesktopMinMarginRight || 0)
            )
        );
        return parsedPopoverDesktopWidth < maxWidth
            ? parsedPopoverDesktopWidth
            : maxWidth;
    }

    getPopoverWidthStyles() {
        const {
            isMobile,
            popoverDesktopWidth,
            popoverDesktopMinWidth,
            popoverDesktopMaxWidth
        } = this.props;
        if (isMobile) {
            return {width: '100%'};
        } else if (popoverDesktopWidth !== 'auto') {
            return {width: `${this.getMaxWidth()}px`};
        }
        return {
            minWidth: popoverDesktopMinWidth,
            maxWidth: popoverDesktopMaxWidth
        };
    }

    renderClearButton = () => {
        const {search, isTypeaheadInputFocus, messages} = this.props;
        const showButton =
            !!search && search.length > 0 && isTypeaheadInputFocus;

        if (showButton) {
            return (
                <button
                    aria-label={messages.clearsearch}
                    className="form-control-feedback search-destination-input__close"
                    tabIndex="0"
                    onClick={this.handleClear}
                    onTouchEnd={this.handleClear}
                    onKeyDown={this.handleKeyDownOnClear}
                >
                    <SVGIcon markup={CLOSE__16} />
                </button>
            );
        }
        return null;
    };

    hasSpinnerAndXhrPending = () => {
        const {showSpinner, results, xhrPending} = this.props;
        return results === false && showSpinner === true && xhrPending === true;
    };

    hasValidResults = () => {
        const {results} = this.props;
        return results !== false && results && results.length !== 0;
    };

    hasValidSearch = () => {
        const {search, isTrendingResults} = this.props;
        return (!!search && search.length > 0) || isTrendingResults;
    };

    showResults = () => {
        const {uistate} = this.props;

        let hasValidUIState = uistate === UISTATES.SELECT_DESTINATION;

        return (
            hasValidUIState &&
            !!this.hasValidSearch() &&
            (this.hasValidResults() || this.hasSpinnerAndXhrPending())
        );
    };

    renderResults() {
        if (this.showResults()) {
            return (
                <div
                    className="search-destination-results-container pop-up-container"
                    tabIndex="-1"
                    style={this.getPopoverWidthStyles()}
                    ref={this.setPopoverRef}
                >
                    <div className="pop-up-container__arrows">
                        <div className="pop-up-container__arrow__outer pop-up-container__arrow" />
                        <div className="pop-up-container__arrow__inner pop-up-container__arrow" />
                    </div>

                    <Results
                        selectDestinationIndex={
                            this.props.selectDestinationIndex
                        }
                        results={this.props.results}
                        search={this.props.search}
                        useAnim={this.props.useResultsAnimation}
                        onSelectDestination={this.props.onSelectDestination}
                        onError={this.props.onError}
                        onBlur={this.handleBlur}
                        isMobile={this.props.isMobile}
                        messages={{
                            noresultsfound: this.props.messages.noresultsfound,
                            recentlyviewed: this.props.messages.recentlyviewed,
                            resultsfound: this.props.messages.resultsfound,
                            destinationselected: this.props.messages
                                .destinationselected,
                            trendingdestinations: this.props.isNearbyAB
                                ? this.props.messages.nearByDestinations
                                : this.props.messages.trendingdestinations,
                            typeairport: this.props.messages.typeairport,
                            typecity: this.props.messages.typecity,
                            typelandmark: this.props.messages.typelandmark,
                            typeneighborhood: this.props.messages
                                .typeneighborhood,
                            typeregion: this.props.messages.typeregion,
                            typetrainstation: this.props.messages
                                .typetrainstation,
                            typemetrostation: this.props.messages
                                .typemetrostation,
                            typeproperty: this.props.messages.typeproperty, // 'Property'
                            premise: this.props.messages.premise,
                            premises: this.props.messages.premises
                        }}
                        showSpinner={this.props.showSpinner}
                        xhrPending={this.props.xhrPending}
                        poweredByGoogle={this.props.poweredByGoogle}
                        showResultIcons={this.props.showResultIcons}
                        showResultLabels={this.props.showResultLabels}
                        skipFilters={this.props.skipFilters}
                        filterType={this.props.filterType}
                        inputHasIcon={!!this.props.icon}
                        truncateResultTerms={this.props.truncateResultTerms}
                        highlightMode={this.props.highlightMode}
                        isTrendingResults={this.props.isTrendingResults}
                    />
                </div>
            );
        }
        return <div />;
    }

    handleFocus = (e) => {
        if (!this.props.isTypeaheadInputFocus) {
            this.callHandler('onFocus', e);
            return true;
        }
        return false;
    };

    handleBlur = () => {
        this.userInput.blur();
        this.callHandler('onBlur');
    };

    handleClear = () => {
        emitDestinationClearedEvent();
        this.userInput.focus();
        this.callHandler('onClear');
    };

    handleKeyDownOnClear = (e) => {
        if (e.keyCode === KEYCODES.ENTER || e.keyCode === KEYCODES.SPACE) {
            e.stopPropagation();
            e.preventDefault();
            this.userInput.focus();

            this.callHandler('onClear');
            return true;
        }
        return false;
    };

    callHandler = (action, ...args) => {
        const handler = this.props[action];
        if (handler && typeof handler === 'function') {
            handler(...args);
            return true;
        }
        return false;
    };

    setUserInputRef = (el) => {
        this.userInput = el;
    };

    setHeaderRef = (el) => {
        this.header = el;
    };

    setPopoverRef = (el) => {
        this.popover = el;
    };

    getPlaceholderText = (inputEmpty) => {
        const {messages} = this.props;
        return inputEmpty ? messages.destinationplaceholdermsg : messages.where;
    };

    getUserInput = () => {
        const {displayTerm, search} = this.props;
        return displayTerm || search || '';
    };

    isInputEmpty = (userInput) => {
        return !(this.isDestinationSelected() || userInput.length > 0);
    };

    renderIcon = () => {
        const {icon} = this.props;
        if (icon) {
            return (
                <span className="form-control-icon search-destination-input__icon">
                    {icon}
                </span>
            );
        }
        return null;
    };

    getSearchInputWrapperAttributes = () => {
        let attrs = {};
        attrs['aria-controls'] = this.showResults()
            ? 'Typeahead__results'
            : null;
        return attrs;
    };

    render() {
        const {
            icon,
            uistate,
            onBlur,
            onClick,
            onChange,
            onKeyDown,
            searchSuggestion,
            usePopoverAnimation
        } = this.props;

        let userInput = this.getUserInput();
        const inputEmpty = this.isInputEmpty(userInput);
        const placeholderText = this.getPlaceholderText(inputEmpty);

        return (
            <div
                className="search-destination-input"
                role="combobox" // eslint-disable-line jsx-a11y/role-has-required-aria-props
                aria-haspopup="listbox"
                aria-expanded={this.showResults()}
                {...this.getSearchInputWrapperAttributes()}
            >
                <div
                    role="presentation"
                    className={`search-destination-input__header${this.assignStateClass()}`}
                    onClick={onClick}
                    ref={this.setHeaderRef}
                >
                    <div
                        className={classnames(
                            'search-destination-input__header__inputs',
                            'form-group',
                            'has-feedback',
                            'floating-label',
                            {
                                'not-empty': !inputEmpty,
                                'has-icon': icon
                            }
                        )}
                        data-toggle="label"
                    >
                        {uistate === UISTATES.SELECT_DESTINATION ? (
                            <input
                                aria-hidden
                                type="text"
                                size="10"
                                className="form-control hint"
                                value={searchSuggestion || ''}
                                readOnly
                                tabIndex={-1}
                                autoComplete="off"
                                autoCapitalize="off"
                                autoCorrect="off"
                                spellCheck="false"
                            />
                        ) : null}
                        <label htmlFor="react-destination-typeahead">
                            {placeholderText}
                        </label>
                        <input
                            type="text"
                            id="react-destination-typeahead"
                            size="10"
                            tabIndex="0"
                            placeholder={placeholderText}
                            className={classnames('control', 'form-control')}
                            onFocus={this.handleFocus}
                            onKeyDown={onKeyDown}
                            onChange={onChange}
                            onBlur={onBlur}
                            value={userInput}
                            autoComplete="off"
                            aria-autocomplete="both"
                            ref={this.setUserInputRef}
                        />
                        {this.renderIcon()}
                        {this.renderClearButton()}
                    </div>
                </div>
                {usePopoverAnimation ? (
                    <CSSTransition
                        in={this.showResults()}
                        classNames="search-destination-results-container"
                        timeout={{enter: 250, exit: 250}}
                        mountOnEnter
                        unmountOnExit
                    >
                        {this.renderResults()}
                    </CSSTransition>
                ) : (
                    this.renderResults()
                )}
            </div>
        );
    }
}
